/**
 * DTO para armazenar a s informações apresentadas no higia-modal.
 *
 */
export default class ModalDto {
    private static instance: ModalDto

    public id = ''
    public persistent = false //boolean
    public titulo = ''
    public mensagem = ''
    public icone = '' //string (alerta, sucesso, erro)
    public tipo = 'default' //default, imagem
    public show = false
    public closed = false
    public btns: any = []
    public imagem = ''
    public currentModal = 0 // (1. Default,2. FullImg,3: Browser nao Compativel,4: Atualização Cadastral, 5 - Erro 401, 6 Modal Validação)
    public codigoErro = 0
    public funcao!: Function
    public data!: any

    /**
     * Singleton's constructor modal dto
     *
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {}

    /**
     * Método estático que controla o acesso à única instância do DTO
     *
     */
    public static getInstance(): ModalDto {
        if (!ModalDto.instance) {
            ModalDto.instance = new ModalDto()
        }
        return ModalDto.instance
    }

    /**
     * Método para criar uma instancia nova do Usuario
     */
    public static createInstance(): ModalDto {
        ModalDto.instance = new ModalDto()
        return ModalDto.instance
    }
}
